export default __webpack_public_path__ + "static/media/tmsrubber.62d66d17.png";